<template>

		<div class="g-facet-set__swatches" :class="{'is-active': facet.overflow.$active}">
			<label class="g-facet-set__swatch-item" v-for="value in facet.values.slice(0, facet.overflow.limit)" :key="value.label" :title="value.label">
				<input class="g-form-checkbox__input" v-model="value.active" type="checkbox" @click="toggleFilter( facet.field, value.type === 'value' ? value.value : [value.low, value.high] )">
				<span class="g-facet-set__swatch-color" :class="{['g-facet-set__swatch-color--' + value.label.replace(/\s/g,'').toLowerCase()]: true }">
					<span class="u-hide-visually">{{ value.label }}</span>
				</span>
			</label>
			<div class="g-facet-view-more" v-if="( facet.values.length > facet.overflow.limit )">
				<input :id="'g-facet-view-more__' + facet.field" class="g-facet-view-more__checkbox u-hide-visually" type="checkbox" @change="viewMoreChange">
				<label class="g-facet-view-more__label" :for="'g-facet-view-more__' + facet.field">View More</label>
				<div class="g-facet-view-more__content">
					<label class="g-facet-set__swatch-item" v-for="value in facet.values.slice(facet.overflow.limit, facet.values.length)" :key="value.label" :title="value.label">
						<input class="g-form-checkbox__input" v-model="value.active" type="checkbox" @click="toggleFilter( facet.field, value.type === 'value' ? value.value : [value.low, value.high] )">
						<span class="g-facet-set__swatch-color" :class="{['g-facet-set__swatch-color--' + value.label.replace(/\s/g,'').toLowerCase()]: true }">
							<span class="u-hide-visually">{{ value.label }}</span>
						</span>
					</label>
				</div>
			</div>
		</div>

</template>

<script>

	import Search from '../../Search';

	export default {
		data() {
			return {
				uniqueId: ''
			}
		},
		props: {
			facet: {
				default() {
					return [];
				}
			}
		},
		methods: {
			toggleFilter ( field, value ) {

				Search.client.filter( field, value ).search();

			},
			viewMoreChange(event) {

				if(event.target.checked) {
					event.target.nextElementSibling.innerText = 'View Less';
				} else {
					event.target.nextElementSibling.innerText = 'View More';
				}

			}
		},
		created() {
			this.uniqueId = this._uid;
		}
	}

</script>

<style lang="scss" scoped>

	@import "variables";

	// List of native cross-browser supported colors
	$swatches: (
		"aliceblue": aliceblue,
		"antiquewhite": antiquewhite,
		"aqua": #28e1c5,
		"aquamarine": aquamarine,
		"ash": #B2BEB5,
		"azure": azure,
		"beige": #F5F5DC,
		"bisque": bisque,
		"black": #212121,
		"blanchedalmond": blanchedalmond,
		"blue": #0074D9,
		"blueviolet": blueviolet,
		"brown": #804D3B,
		"burgandy": #800020,
		"burgundy": #800020,
		"burlywood": burlywood,
		"burntorange": #CC5500,
		"cadetblue": cadetblue,
		"cardinal": #BD2031,
		"carharttbrown": #BD8850,
		"charcoal": #36454f,
		"chartreuse": chartreuse,
		"chocolate": chocolate,
		"coral": coral,
		"cornflowerblue": cornflowerblue,
		"cornsilk": cornsilk,
		"crimson": #990000,
		"cyan": cyan,
		"darkblue": darkblue,
		"darkcyan": darkcyan,
		"darkgoldenrod": darkgoldenrod,
		"darkgray": darkgray,
		"darkgrey": #A9A9A9,
		"darkgreen": darkgreen,
		"darkkhaki": darkkhaki,
		"darkmagenta": darkmagenta,
		"darkolivegreen": darkolivegreen,
		"darkorange": darkorange,
		"darkorchid": darkorchid,
		"darkred": darkred,
		"darksalmon": darksalmon,
		"darkseagreen": darkseagreen,
		"darkslateblue": darkslateblue,
		"darkslategray": darkslategray,
		"darkturquoise": darkturquoise,
		"darkviolet": darkviolet,
		"deeppink": deeppink,
		"deepskyblue": deepskyblue,
		"dimgray": dimgray,
		"dodgerblue": dodgerblue,
		"firebrick": firebrick,
		"floralwhite": floralwhite,
		"forestgreen": forestgreen,
		"fuchsia": fuchsia,
		"gainsboro": gainsboro,
		"ghostwhite": ghostwhite,
		"gold": #D4AF37,
		"goldenrod": goldenrod,
		"graphite":#41424C,
		"gray": #9C9C9C,
		"green": #008000,
		"greenyellow": greenyellow,
		"grey": #9C9C9C,
		"honeydew": honeydew,
		"hotpink": hotpink,
		"indianred": indianred,
		"indigo": indigo,
		"ivory": #FFFFF0,
		"kellygreen": #4CBB17,
		"khaki": #C3B091,
		"lavender": #CBBDF2,
		"lavenderblush": lavenderblush,
		"lawngreen": lawngreen,
		"lemonchiffon": lemonchiffon,
		"lightblue": #66CCFF,
		"lightcoral": lightcoral,
		"lightcyan": lightcyan,
		"lightgoldenrodyellow": lightgoldenrodyellow,
		"lightgreen": lightgreen,
		"lightgrey": lightgrey,
		"lightpink": lightpink,
		"lightsalmon": lightsalmon,
		"lightseagreen": lightseagreen,
		"lightskyblue": lightskyblue,
		"lightslategray": lightslategray,
		"lightsteelblue": lightsteelblue,
		"lightyellow": #FFEE7A,
		"lilac": #CEADD0,
		"lime": #C3D600,
		"limegreen": limegreen,
		"linen": linen,
		"magenta": magenta,
		"maroon": #800000,
		"mediumaquamarine": mediumaquamarine,
		"mediumblue": mediumblue,
		"mediumorchid": mediumorchid,
		"mediumpurple": mediumpurple,
		"mediumseagreen": mediumseagreen,
		"mediumslateblue": mediumslateblue,
		"mediumspringgreen": mediumspringgreen,
		"mediumturquoise": mediumturquoise,
		"mediumvioletred": mediumvioletred,
		"midnightblue": midnightblue,
		"midnightgreen": #004851,
		"mintcream": mintcream,
		"mistyrose": mistyrose,
		"moccasin": moccasin,
		"natural": #DED7C9,
		"navajowhite": navajowhite,
		"navy": #002D5D,
		"navyblue": #003366,
		"oatmeal": #BDAE95,
		"oldlace": oldlace,
		"olive": #808000,
		"olivedrab": olivedrab,
		"orange": #FF5200,
		"orangered": orangered,
		"orchid": orchid,
		"palegoldenrod": palegoldenrod,
		"palegreen": palegreen,
		"paleturquoise": paleturquoise,
		"palevioletred": palevioletred,
		"papayawhip": papayawhip,
		"peach": #FFCC8C,
		"peachpuff": peachpuff,
		"peru": peru,
		"pink": #FFA5C1,
		"plum": plum,
		"powderblue": powderblue,
		"purple": #9400D3,
		"red": #F63440,
		"rosybrown": rosybrown,
		"royalblue": royalblue,
		"saddlebrown": saddlebrown,
		"salmon": salmon,
		"sandybrown": sandybrown,
		"seagreen": seagreen,
		"seashell": seashell,
		"sienna": sienna,
		"silver": #C0C0C0,
		"skyblue": skyblue,
		"slateblue": slateblue,
		"slategray": slategray,
		"snow": snow,
		"springgreen": springgreen,
		"steelblue": steelblue,
		"tan": #BA9A65,
		"teal": #00AB95,
		"thistle": thistle,
		"tomato": tomato,
		"turquoise": turquoise,
		"violet": violet,
		"wheat": wheat,
		"white": white,
		"whitesmoke": whitesmoke,
		"yellow": #FFDE00,
		"yellowgreen": yellowgreen
	);

	// Generate the swatch color classes
	@each $name, $color in $swatches {

		.g-facet-set__swatch-color--#{$name} {
			background-color: $color;
		}

	}

</style>
